<template>
  <iconSettings @click="toggleMenu" :disabled="!isAuthenticated" />
  <DropDownSettings :items="dropDownItems" :open="isOpen" @activate="selectedOption" />
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'
import iconSettings from '@/components/icons/iconSettings.vue'
import DropDownSettings from '@/components/common/DropDownSettings.vue'
import { DropdownItem } from '@/components/types'
import { useLanguageStore } from '@/stores/language'
import { authService } from '@/components/services/authentication'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
export default defineComponent({
  components: {
    iconSettings,
    DropDownSettings
  },

  name: 'MenuSettings',
  setup() {
    const { t } = useI18n()
    const router = useRouter()
    const isAuthenticated = computed(() => {
      return authService.isAuthenticated()
    })

    const languageStore = useLanguageStore()
    const dropDownItems = ref<DropdownItem[]>([
      new DropdownItem(1, t('message.select_language')),
      // user profile management not yet functional
      new DropdownItem(2, t('message.user_profile')),
      new DropdownItem(3, t('message.logout')),
    ])

    const isOpen = ref(false)
    const toggleMenu = (): void => {
      if (isAuthenticated.value) {
        isOpen.value = !isOpen.value
      }
    }

    const selectedOption = (value: number) => {
      switch (value) {
        case 1:
          break
        case 2:
          router.push('/user_settings')
          break
        case 3:
          {
            authService.logout()
            router.push('/')
          }
          break
      }
      toggleMenu()
    }
    function updateTranslationsForItems() {
      const dropDownItemsTranslated = dropDownItems.value.map((item) => {
        switch (item.id) {
          case 1:
            item.label = t('message.select_language')
            break
          case 2:
            item.label = t('message.user_profile')
            break
          case 3:
            item.label = t('message.logout')
            break
          default:
            break
        }
        return item
      })
      dropDownItems.value = dropDownItemsTranslated
    }
    // TODO: How to watch for lang without using lang and no typescript warning?
    watch(
      () => languageStore.language,
      (lang) => {
        updateTranslationsForItems()
      }
    )
    return {
      isAuthenticated,
      selectedOption,
      dropDownItems,
      isOpen,
      toggleMenu
    }
  }
})
</script>
<style module>
.settingsIcon {
  width: 100%;
  position: relative;
  height: 24px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 9999;
}

.iconButton.hover {
  background-color: #0000001a;
}
.iconButton.active {
  background-color: var(--black);
}
</style>
